import Phaser from 'phaser';
import StoryAnimation from '../ui/story/StoryAnimation';
import ScreenContainer from '../display/ui/ScreenContainer';
import LoadDisplay from '../display/ui/LoadDisplay';
import Hud from 'app/ui/hud/Hud';
import { UnloadAssetPack } from '../../utils/AssetpackUnloader';

// I'm bored of watching these, sure you will be too
// set skip to false if you need them :)
// const skip = __WATCH__;
const skip = false;
export default class AnimaticStoryBase extends Phaser.State {
  init({ watched, assets = 'intro', extraAssets }) {
    this.watched = watched;
    this.assets = assets;
    this.extraAssets = extraAssets || [];
  }

  preload() {
    if (skip) {
      return;
    }
    // store everything in a container, it will reposition for screen
    this.container = new ScreenContainer(this.game, {
      background: 'background_generic',
      overlay: true,
    });
    this.game.add.existing(this.container);

    this.loadDisplay = new LoadDisplay(this.game, true);
    this.loadDisplay.x = this.game.defaultWidth * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.game.defaultHeight * 0.5 - this.loadDisplay.height * 0.5;
    this.container.add(this.loadDisplay);

    // Overlay
    // THis bgOverlay gets repeat alot in different places.
    // Maybe seoerate out?
    /*

      good shout, we could put it in it's own class with an auto center option

    */
    this.bgOverlay = this.game.add.image(0, 0, 'background_alt_overlay');
    this.bgOverlay.anchor.set(0.5);
    this.bgOverlay.x = this.game.defaultWidth * 0.5;
    this.bgOverlay.y = this.game.defaultHeight * 0.5;
    this.mapOverlay = this.game.make.group();
    this.mapOverlay.fixedToCamera = true;
    this.mapOverlay.cameraOffset.x = (this.game.width - this.game.defaultWidth) / 2;
    this.mapOverlay.cameraOffset.y = (this.game.height - this.game.defaultHeight) / 2;
    this.mapOverlay.add(this.bgOverlay);

    this.game.load.baseURL = './assets/story/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack(this.assets, 'assetpack.json', null, this);
    this.game.load.pack('general', 'assetpack.json', null, this);
    this.game.load.json('storyassets', 'assetpack.json', null, this);
    if (this.extraAssets) {
      this.extraAssets.forEach((asset) => {
        this.game.load.pack(asset, 'assetpack.json', null, this);
      });
    }
    if (this.localAsssets) {
      this.game.load.pack('assets', null, this.localAsssets);
    }

    this.game.load.onFileComplete.add(this.fileComplete, this);
  }

  create() {
    if (skip) {
      this.handleComplete();
      return;
    }
    this.loadDisplay.destroy();

    //
    AnimaticStoryBase.PreviousAssetPack = this.game.cache.getJSON('storyassets', true);

    // register sounds
    Object.keys(AnimaticStoryBase.PreviousAssetPack).forEach((key) => {
      const assets = AnimaticStoryBase.PreviousAssetPack[key];
      assets.forEach((item) => {
        switch (item.type) {
          case 'audiosprite':
            this.game.sounds.addAudioSprite({ id: item.key });
            break;
          case 'audio':
            this.game.sounds.addSound(item.key, item.key);
            break;
        }
      });
    });

    // register vo
    if (this.localAsssets) {
      Object.keys(this.localAsssets).forEach((key) => {
        const assets = this.localAsssets[key];
        assets.forEach((item) => {
          switch (item.type) {
            case 'audiosprite':
              this.game.sounds.addAudioSprite({ id: item.key });
              break;
            case 'audio':
              this.game.sounds.addSound(item.key, item.key);
              break;
          }
        });
      });
    }

    //
    this.animation = new StoryAnimation(this.game, this.game.cache.getJSON('storyanimdata'));
    this.animation.onComplete.add(this.handleComplete, this);
    this.container.add(this.animation);

    this.vignette = this.game.make.image(0, 0, 'story_vignette');
    this.vignette.scale.set(2);
    this.container.add(this.vignette);

    this.hud = new Hud(this.game, this.watched ? Hud.CUTSCENE_WATCHED : Hud.CUTSCENE);
    this.hud.onButtonSelect.add(this.handleHudButton, this);

    if (this.watched) {
      this.btnSkip = this.hud.getButton('skip');
      this.btnSkip.visible = false;
      this.btnSkip.alpha = 0;
      this.game.add.existing(this.hud);
      this.revealButton();
    }

    // play music - i dont know why the music does not start directly at the beginning, it needs some delay
    this.game.time.events.add(100, this.playMusic, this);
  }

  playMusic() {
    this.game.sounds.setBackgroundMusic('music_story', true);
  }

  revealButton() {
    this.btnSkip.visible = true;
    this.game.add
      .tween(this.btnSkip)
      .to({ alpha: 1 }, 500)
      .start();
  }

  handleHudButton(btnid) {
    switch (btnid) {
      case 'skip':
        this.handleComplete();
        break;
    }
  }

  fileComplete(progress, cacheKey, success, totalLoaded, totalFiles) {
    this.loadDisplay.progress = progress;
  }

  handleComplete() {
    this.game.gameController.triggerWorldState();
  }

  shutdown() {
    this.game.sounds.stopBackgroundMusic();

    if (this.animation) {
      this.game.load.onFileComplete.remove(this.fileComplete, this);
      this.animation.onComplete.remove(this.handleComplete, this);
      this.animation.destroy(true);
      this.animation = null;

      this.container.destroy(true);
      this.container = null;
      this.hud.destroy(true);
      this.hud = null;
    }

    UnloadAssetPack(this.game, AnimaticStoryBase.PreviousAssetPack);
    if (this.localAsssets) {
      UnloadAssetPack(this.game, this.localAsssets);
      this.localAsssets = null;
    }
  }
}

AnimaticStoryBase.PreviousAssetPack = {};



// WEBPACK FOOTER //
// ./js/app/states/AnimaticStoryBase.js